class ProductCarousel extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.carousel = this.querySelector(".carousel--root")),
            (this.media = this.carousel.querySelectorAll(".product-media--root")),
            (this.transition_container = this.carousel.querySelector(".carousel--x-container"));
            this.carousel.on("loaded", () => {
                this.updateMediaListener(), this.onSlideFinishedListener();
                var e = this.querySelector('.product-media--root[data-active="true"]');
                var mediaAlt = e.getAttribute('data-media-alt');
                var id = e.getAttribute('data-id');
                this.goToSlide(parseInt(id), mediaAlt);
                this.onSlideFinishedListener();
            });
    }
    updateMediaListener() {
        window.on(`theme:product:${this.dataset.id}:variantChanged`, ({ detail: { variant: e } }) => {
            var t = e.featured_media ? parseInt(e.featured_media.id) : 0;
            var alt = e.featured_media.alt;
            this.goToSlide(t, alt);
        });
    }
    onSlideFinishedListener() {
        this.transition_container.on("transitionend", () => {
            var e = this.carousel.active_slide - 1,
                t = this.media[e];
            this.media.not(t).forEach((e) => {
                if (e && e.firstChild) {
                    if (typeof e.firstChild.pause === 'function') {
                        e.firstChild.pause();
                    }
                }
            
            });
        });
    }
    goToSlide(e, alt) {
        let targetElement, index;
        if (e !== 0) {
            targetElement = this.carousel.querySelector(`.product-media--root[data-id='${e}']`);
            if (!targetElement) {
                targetElement = this.carousel.querySelector(`.product-media--root[data-media-alt*='${alt}']`);
            }
            if (targetElement) {
                index = targetElement.closest(".carousel--block").index() + 2;
                this.carousel.updateThenGoToActiveSlide(index);
            }
        }
    }
}
const productCarouselEl = customElements.get("product-media-carousel");
productCarouselEl || customElements.define("product-media-carousel", ProductCarousel);
